import {BaseContainerModel} from '../base-container.model';
import {
  bl_prt_printable_format_ext_RowInterface,
  bl_prt_printable_format_ext_RowClass
} from '../../dbschema/index';

export class PrintableFormatExtContainerModel extends BaseContainerModel {
  bl_prt_printable_format_ext: bl_prt_printable_format_ext_RowInterface = new bl_prt_printable_format_ext_RowClass();
}
